'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();
import Script from 'next/script'
import {
  ComponentProps,
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useId,
  useState,
} from 'react'
import { ErrorBoundary } from 'react-error-boundary'

const HubspotFormContext = createContext<{ isLoaded: boolean } | null>(null)

function useHubspotFormContext() {
  const context = useContext(HubspotFormContext)
  if (!context) {
    throw new Error(
      'useHubspotFormContext must be used within a HubspotFormProvider',
    )
  }
  return context
}

export function HubspotFormProvider({ children }: { children: ReactNode }) {
  const [isLoaded, setIsLoaded] = useState(false)

  return (
    <HubspotFormContext.Provider value={{ isLoaded }}>
      <Script
        src="//js-eu1.hsforms.net/forms/embed/v2.js"
        strategy="lazyOnload"
        onLoad={() => setIsLoaded(true)}
      />
      {children}
    </HubspotFormContext.Provider>
  )
}

export function HubspotForm(props: ComponentProps<typeof HubspotFormInner>) {
  return (
    <ErrorBoundary fallback={null}>
      <HubspotFormInner {...props} />
    </ErrorBoundary>
  )
}

function HubspotFormInner({
  formId,
  cssClass,
  fallback = null,
}: {
  formId: string
  cssClass: string
  fallback?: ReactNode
}) {
  const { isLoaded } = useHubspotFormContext()
  const formTargetId = useId()

  useEffect(() => {
    if (isLoaded) {
      window.hbspt?.forms.create({
        region: 'eu1',
        portalId: '139645065',
        formId,
        cssClass,
        target: `#${formTargetId}`,
      })
    }
  }, [isLoaded, formId, cssClass, formTargetId])

  if (!isLoaded) {
    return fallback
  }

  return <div id={formTargetId} />
}

declare global {
  interface Window {
    hbspt?: {
      forms: {
        create: (config: HubspotFormConfig) => void
      }
    }
  }
}

type HubspotFormConfig = {
  region: string
  portalId: string
  formId: string
  target: string
  cssClass: string
}
